import { useRecoilValue } from "recoil";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { request } from "../lib/api";
import { userState } from "../states/user";
import {
  ONGOING_TRANSPORTATIONS,
  TRANSPORTATIONS_PERFORMANCE,
} from "../common/query-keys";
import {
  TransportationPerformanceType,
  TransportationType,
} from "../interface/transportation";

import { MainContentsList } from "../components/organisms/mainContentsList";
import { MainProfile } from "../components/organisms/mainProfile";
import { MainTemplates } from "../components/template/MainTemplates";
import { ResponseType } from "../types/response.types";
import { useNavigate } from "react-router";
import { useState } from "react";
import AlertModal from "../components/molcules/Modal/AlertModal";

const HomePage = () => {
  /** ============================= state 영역 ============================= */
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const user = useRecoilValue(userState);
  /** 기사 운송 취소 요청 모달 상태 */
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);

  /** ============================= API 영역 ============================= */
  const { data: transportations, isLoading } = useQuery({
    queryKey: [ONGOING_TRANSPORTATIONS],
    queryFn: async () => {
      const result = await request<TransportationType[]>({
        method: "GET",
        url: ONGOING_TRANSPORTATIONS,
      });
      return result;
    },
  });

  /** 전월 대비 운송 실적 가시화 데이터 */
  const { data: performanceData, isLoading: performanceLoading } = useQuery({
    queryKey: [TRANSPORTATIONS_PERFORMANCE],
    queryFn: async () => {
      const result = await request<ResponseType<TransportationPerformanceType>>(
        {
          method: "GET",
          url: TRANSPORTATIONS_PERFORMANCE,
        }
      );
      return result.data;
    },
  });

  /** 기사운송 취소 요청api
   * @param type ( TRANSPORTATION_CANCEL_REQUEST )
   */
  const { mutateAsync: cancelTransportationRequest } = useMutation({
    mutationFn: (data: { orderNumber: string; transportationId: string }) => {
      return request<ResponseType<any>>({
        method: "PATCH", // PATCH 요청을 사용하여 서버에 변경 사항 전달
        url: `/user/cancel-request`,
        data: {
          orderNumber: data.orderNumber,
          transportationId: data.transportationId,
        },
      });
    },
    onSuccess: (res: ResponseType<any>) => {
      // 성공 시 회원관리 테이블 리페칭
      if (res.success) {
        queryClient.invalidateQueries({ queryKey: [] });
        setIsCancelRequest(false);
      }
    },
  });

  /** ============================= 비즈니스 로직 영역 ============================= */
  const moveToMatchlist = () => {
    navigate("/matchlist");
  };

  const moveToMatchListDetail = () => {
    navigate("/task-chargeTransfer");
  };

  /** 기사 운송 취소 요청 모달 */
  const handleCancelRequest = () => {
    setIsCancelRequest(!isCancelRequest);
  };

  /** 기사 현재 운송 취소 요청 함수 */
  const onTransportationCancel = async () => {
    console.log("onTransportationCancel", transportations?.[0]);
    if (transportations?.[0]) {
      const { order_number, transportation_id } = transportations?.[0];

      await cancelTransportationRequest({
        orderNumber: order_number,
        transportationId: transportation_id,
      });
    }
  };

  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */

  return (
    <MainTemplates pageTitle="홈">
      <>
        <MainProfile
          count={performanceData?.currentMonthCount ?? 0}
          user={user}
          performanceData={performanceData}
        />

        <MainContentsList
          contentTit="운송정보"
          transportations={transportations ?? []}
          isLoading={isLoading}
          moveToMatchlist={moveToMatchlist}
          moveToMatchListDetail={moveToMatchListDetail}
          handleCancelRequest={handleCancelRequest}
        />
        {isCancelRequest && (
          <AlertModal
            setIsModal={setIsCancelRequest}
            title="알림"
            description={
              <>
                "진행중인 운송을 취소 하시겠습니까? <br />
                취소 요청 후 취소 처리 까지 최대 24시간 소요됩니다."
              </>
            }
            onSubmit={onTransportationCancel}
          />
        )}
        {/* <MainDispatchList
            contentTit="배차정보"
            transportations={[]}
            isLoading={isLoading}
            moveToMatchlist={moveToMatchlist}
            moveToMatchListDetail={moveToMatchListDetail}
          /> */}
      </>
    </MainTemplates>
  );
};
export default HomePage;
